























import { Component, Prop, Vue } from 'vue-property-decorator';

import { Button } from '@/components/core';

@Component({
  components: { Button },
})
export default class Track extends Vue {
  @Prop({ default: -1 }) private index: number;
  @Prop({ default: null }) private model: ITrackData;
  @Prop({ default: () => ({}) }) private mods!: Hash;

  private blockName: string = 'track';

  private onClick() {
    this.$emit('click');
  }

  private onDelete() {
    this.$emit('delete');
  }
}
